import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  LOADER_FALSE,
  LOADING_DATA,
  VISITOR_LIST,
  VISITOR_VIEW,
  VISITOR_I,
  LOADER_CHECK,
} from '../type';
import axios from 'axios';
import { toast } from 'react-toastify';
import { VisitorUrl } from '../../Component/Helpers/api';
import { VisitorViews } from '../../Component/Helpers/api';
import { dataLocation } from '../../Component/Helpers/util';
import $ from 'jquery';

const userDataLocal1 = dataLocation();

var LocationObj = JSON.parse(userDataLocal1);

export const VisitorData = chartType => dispatch => {

  dispatch({ type: LOADER_CHECK }); // ✅ start loader

  chartType.location = chartType.location
    ? chartType.location
    : JSON.stringify(LocationObj);

  let authToken = JSON.parse(localStorage.getItem('headData'));

  axios
    .post(VisitorUrl.data, chartType, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: VISITOR_LIST, payload: res.data.data });
      }

      dispatch({ type: LOADER_FALSE }); // ✅ stop loader
    })
    .catch(error => {
      dispatch({ type: LOADER_FALSE }); // ✅ stop loader
    });
};




export const CheckLoader = () => dispatch => {
  dispatch({ type: LOADER_FALSE });
};

export const SetView = params => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(VisitorViews.data, params,{headers: {

      Authorization: authToken?.spintlyToken,

    }})
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: VISITOR_VIEW, payload: res.data.data });
        dispatch({ type: VISITOR_I, payload: params });
        dispatch({ type: CLEAR_ERRORS });
        // toast.success(res.data.message, {

        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};
